import React, { useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import * as S from './styles';

import { TweetyWidget } from '@/widgets/tweety-widget-react-main';

export interface IContactUsFormProps {
  sectionId?: string;
  contactUsFormConfig?: any;
}

export const ContactUsForm: React.FC<IContactUsFormProps> = ({ sectionId, contactUsFormConfig }) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    reason: '',
    specifics: '',
    email: '',
    phone: '',
    reference: '',
    message: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
  };

  const renderSubmitButton = (props: any) => {
    return (
        <Col className="m-auto">
            <div className="mt-3">
                <Button
                    variant="secondary"
                    type="submit"
                    className="mt-2 animate-up-2"
                    style={{
                        borderRadius: '10px',
                        height: '50px',
                        width: '100%',
                        fontWeight: 'bold',
                        background:
                            'linear-gradient(to bottom right,#2f78d1,#104382)',
                    }}
                >
                    Submit
                </Button>
            </div>
        </Col>
    );            
  };

  console.log('AsircontactUsFormConfig', contactUsFormConfig);
  return (
    <section className="section section-md bg-gray-100 pt-lg-5" id={sectionId}>
      <Container>
        <Row className="justify-content-center">
          <Col lg={12}>
            <S.Title>Contact Us</S.Title>
            <S.Description className="text-[#666666] mb-4">
              Have a question or need assistance? Reach out to us using the form and sending us your inquiry below. We’ll respond as soon as possible.
            </S.Description>
          </Col>
        </Row>
        <Row className="justify-content-between align-items-start">
          <Col lg={6} className="mb-5 mb-lg-0">
            <TweetyWidget
                {...contactUsFormConfig}
                key={'contactUsForm'}
                labelColor={'#104382'}
                renderSubmitButton={renderSubmitButton}
                onChange={(id: any, payload: any) =>{
                              
                }}
                // initialData={{ ...userInitialData }}
                onFormSubmit={(payload: any) => {
                       
                }}
            />
          </Col>
          <Col lg={6}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3794.621173465473!2d-76.79134488564837!3d18.008611787714156!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8edb3f7d9c5a5b1b%3A0x8e6e5a5a5a5a5a5a!2sMinistry%20of%20Labour%20and%20Social%20Security!5e0!3m2!1sen!2sjm!4v1698161234567!5m2!1sen!2sjm"
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

ContactUsForm.defaultProps = {
  sectionId: 'contact-us-form',
};

export default ContactUsForm;